import { ParsedUrlQuery } from 'querystring'
import { LimitType } from 'shared/types/pagination-interface'

export const setLimitFromQuery = (query: ParsedUrlQuery): LimitType =>
  query.limit ? (Number(query.limit) as LimitType) : 10
